// Apenas o valor dos itens atuais (sem impostos), como esperado por validarCarrinho.
// Não use totais agregados do grupo: eles podem sobreviver à remoção de um SKU.
export function itensBudgetOperacao(grupos) {
  return (grupos || []).reduce((itens, grupo) => {
    (grupo.itens || []).forEach((item) => {
      const quantidade = Number(item.pedidoItemQuantidade);
      const preco = Number(item.precoUnitario);
      const valor = item.pedidoItemQuantidade != null && item.precoUnitario != null
        && Number.isFinite(quantidade) && Number.isFinite(preco)
        ? quantidade * preco : Number(item.valorTotal ?? item.ValorTotal);
      if (item.itemId || item.itemid) {
        itens.push({ item_id: item.itemId || item.itemid, valor: Number.isFinite(valor) ? valor : 0 });
      }
    });
    return itens;
  }, []);
}

export function itensBudgetCarrinho(pedidoItens) {
  return (pedidoItens || []).filter(item => item.item_id).map((item) => {
    const quantidade = Number(item.pedido_item_quantidade);
    const preco = Number(item.pedido_item_preco_unitario);
    const valor = item.pedido_item_quantidade != null && item.pedido_item_preco_unitario != null
      && Number.isFinite(quantidade) && Number.isFinite(preco)
      ? quantidade * preco : Number(item.valor_total);
    return { item_id: item.item_id, valor: Number.isFinite(valor) ? valor : 0 };
  });
}